export default {"src":"/_next/static/media/fluent-calendar.dcda29d2.svg","height":34,"width":34};